import { useSelector } from 'react-redux';
import { getSdkApplicationsSelector } from 'js/reducers/sdkApplications';

export function useGetSdkApplications() {
  return useSelector(getSdkApplicationsSelector);
}
